// Using public URLs for better performance and to avoid bundle size issues
const battingKing1 = "/images/Projects/Batting-King/cover.svg";
const battingKing2 = "/images/Projects/Batting-King/cover-2.svg";
const battingKing3 = "/images/Projects/Batting-King/cover-3.svg";
const battingKing4 = "/images/Projects/Batting-King/cover-4.svg";
const homeWorkRabbitAI = "/images/Projects/Home-Work-Rabbit/cover-1.png";
const homeWorkRabbitAI2 = "/images/Projects/Home-Work-Rabbit/cover-2.png";
const homeWorkRabbitAI3 = "/images/Projects/Home-Work-Rabbit/cover-3.png";
const rafiqApp1 = "/images/Projects/Rafiq App/cover-1.png";
const rafiqApp2 = "/images/Projects/Rafiq App/cover-2.png";
const rafiqApp3 = "/images/Projects/Rafiq App/cover-3.png";
const coverLap1 = "/images/Projects/CoverLap/cover-1.png";
const coverLap2 = "/images/Projects/CoverLap/cover-2.png";
const coverLap3 = "/images/Projects/CoverLap/cover-3.png";
const freeToolZone1 = "/images/Projects/Free Tool Zone/cover-1.png";
const freeToolZone2 = "/images/Projects/Free Tool Zone/cover-2.png";
const freeToolZone3 = "/images/Projects/Free Tool Zone/cover-3.png";
const travelacco1 = "/images/Projects/Travelacco/cover-1.png";
const travelacco2 = "/images/Projects/Travelacco/cover-2.png";
const travelacco3 = "/images/Projects/Travelacco/cover-3.png";
const kycpal1 = "/images/Projects/KYCPAL/cover-1.png";
const kycpal2 = "/images/Projects/KYCPAL/cover-2.png";
const kycpal3 = "/images/Projects/KYCPAL/cover-3.png";
const typeOut1 = "/images/Projects/Type Out/cover-1.png";
const typeOut2 = "/images/Projects/Type Out/cover-2.png";
const typeOut3 = "/images/Projects/Type Out/cover-3.png";
const kalbosoft1 = "/images/Projects/Kalbosoft/cover-1.png";
const kalbosoft2 = "/images/Projects/Kalbosoft/cover-2.png";
const kalbosoft3 = "/images/Projects/Kalbosoft/cover-3.png";
const watcherAd1 = "/images/Projects/Watcher-Admin/cover-1.svg";
const watcherAd2 = "/images/Projects/Watcher-Admin/cover-2.svg";
const watcherAd3 = "/images/Projects/Watcher-Admin/cover-3.svg";
const orderUK = "/images/Projects/Order.Uk/cover.svg";
const rafiq_2 = "/images/Projects/Rafiq-Dashboard/cover-2.svg";
const rafiq_3 = "/images/Projects/Rafiq-Dashboard/cover-3.svg";
const rafiq_4 = "/images/Projects/Rafiq-Dashboard/cover-4.svg";
const rafiq_5 = "/images/Projects/Rafiq-Dashboard/cover-5.svg";
const URLShortner_1 = "/images/Projects/URL-Shortner-App/cover.svg";
const URLShortner_2 = "/images/Projects/URL-Shortner-App/conver-2.svg";
const Estatein = "/images/Projects/Estatein/cover.svg";
const Estatein_2 = "/images/Projects/Estatein/cover-2.svg";
export const projects = [
  [
    {
      title: "Homework Rabbit - Fastest AI Homework Helper",
      description:
        "Solo-developed full-stack AI platform delivering instant, step-by-step homework solutions across 15+ subjects (Math, Calculus, Physics, Chemistry, Literature, History, Geography & more). Users input via text, photo upload (OCR), or voice — receiving detailed, expert-verified explanations in ~2.3 seconds. Built with Next.js, NextAuth, and Convex. Stats: 500K+ problems solved, 99% accuracy, 4.9/5 rating with testimonials from Princeton, Stanford, MIT students.",
      img: homeWorkRabbitAI,
      category: "AI Educational Platform",
      link: "https://www.homeworkrabbit.com",
    },
    {
      title: "Homework Rabbit - Public Playground & Dashboard",
      description:
        "Zero-friction public playground at /playground — visitors can instantly type questions, drag-drop images, or try examples and get full step-by-step AI responses without signing up. Secure authentication (Google + email) leads to personalized dashboard with progress analytics, subject-wise success rates tracking, and adaptive learning recommendations. Freemium model with premium plans for unlimited solves.",
      img: homeWorkRabbitAI2,
      category: "AI Educational Platform",
      link: "https://www.homeworkrabbit.com/playground",
    },
    {
      title: "Homework Rabbit - Full Product Development",
      description:
        "End-to-end product development: Homepage with hero upload interface, feature showcase, real-time example solver, and social proof. AI pipeline includes image OCR/recognition, NLP for text/voice, equation solving with contextual explanations. Performance: ~2.3s response time, 99.9% uptime. Mobile-responsive UX with intuitive flow from landing → try → sign-up → dashboard. 500K+ students helped worldwide.",
      img: homeWorkRabbitAI3,
      category: "AI Educational Platform",
      link: "https://www.homeworkrabbit.com",
    },
  ],
  [
    {
      title: "Rafiq App - Islamic Mobile Application",
      description:
        "I developed this comprehensive Islamic mobile application using React Native and modern mobile technologies. It's a full-featured app providing prayer times, Quran recitation, mosque finder, Islamic calendar, and community features for Muslims worldwide. Available on Google Play Store.",
      img: rafiqApp1,
      category: "Mobile Application",
      link: "https://play.google.com/store/apps/details?id=com.rafiqapp&hl=en_US&pli=1",
    },
    {
      title: "Rafiq App - Prayer & Quran Features",
      description:
        "Advanced Islamic companion featuring accurate prayer time notifications, full Quran with translations, audio recitations, Qibla direction finder, and daily Islamic reminders. Built with offline support for seamless spiritual practice.",
      img: rafiqApp2,
      category: "Mobile Application",
      link: "https://play.google.com/store/apps/details?id=com.rafiqapp&hl=en_US&pli=1",
    },
    {
      title: "Rafiq App - Community & Resources",
      description:
        "Comprehensive Islamic knowledge platform with mosque locator, Islamic event calendar, hadith collections, dua compilations, and community engagement features. Designed to support Muslims in their daily spiritual journey.",
      img: rafiqApp3,
      category: "Mobile Application",
      link: "https://play.google.com/store/apps/details?id=com.rafiqapp&hl=en_US&pli=1",
    },
  ],
  [
    {
      title: "CoverLap - AI Cover Letter Generator",
      description:
        "I developed this innovative AI-powered cover letter generation platform using Next.js and modern web technologies. It's a full-stack application featuring intelligent letter writing, customizable templates, industry-specific content, ATS optimization, and real-time editing for professional job applications.",
      img: coverLap1,
      category: "Career Platform",
      link: "https://coverclap.com",
    },
    {
      title: "CoverLap - Smart Template Builder",
      description:
        "Advanced template customization system with AI-powered content suggestions, professional formatting, keyword optimization, and multiple export formats. Built to help job seekers create compelling cover letters that stand out to recruiters.",
      img: coverLap2,
      category: "Career Platform",
      link: "https://coverclap.com",
    },
    {
      title: "CoverLap - Career Success Dashboard",
      description:
        "Comprehensive job application tracking platform featuring application management, interview scheduling, cover letter history, success analytics, and career resources. Designed to streamline the job search process and increase application success rates.",
      img: coverLap3,
      category: "Career Platform",
      link: "https://coverclap.com",
    },
  ],
  [
    {
      title: "Free Tool Zone - All-in-One Utility Platform",
      description:
        "I developed this comprehensive free online tools platform using Next.js and modern web technologies. It's a full-stack application featuring text tools, image converters, calculators, code formatters, and productivity utilities. Designed to provide essential tools for developers, students, and professionals.",
      img: freeToolZone1,
      category: "Web Tools Platform",
      link: "https://freetoolzone.com",
    },
    {
      title: "Free Tool Zone - Developer & Text Tools",
      description:
        "Advanced developer toolkit with JSON formatter, base64 encoder/decoder, regex tester, code beautifier, and text manipulation tools. Built with modern UI for seamless tool usage and instant results without registration.",
      img: freeToolZone2,
      category: "Web Tools Platform",
      link: "https://freetoolzone.com",
    },
    {
      title: "Free Tool Zone - Productivity & Converters",
      description:
        "Comprehensive utility collection featuring image converters, unit calculators, password generators, color pickers, and file conversion tools. Provides fast, secure, and privacy-focused online tools accessible from any device.",
      img: freeToolZone3,
      category: "Web Tools Platform",
      link: "https://freetoolzone.com",
    },
  ],
  [
    {
      title: "Travelacco - Travel Booking Platform",
      description:
        "I developed this comprehensive travel booking platform using Next.js and modern web technologies. It's a full-stack application featuring flight bookings, hotel reservations, tour packages, travel itinerary planning, and secure payment processing for seamless travel experiences.",
      img: travelacco1,
      category: "Travel & Booking",
      link: "https://traveloacco-frontend.vercel.app",
    },
    {
      title: "Travelacco - Destination Explorer",
      description:
        "Advanced travel discovery platform with destination guides, attraction recommendations, user reviews, interactive maps, and personalized travel suggestions. Built with responsive design to help travelers plan their perfect journey.",
      img: travelacco2,
      category: "Travel & Booking",
      link: "https://traveloacco-frontend.vercel.app",
    },
    {
      title: "Travelacco - Booking Management Dashboard",
      description:
        "Comprehensive travel management system featuring booking history, itinerary organization, price alerts, trip reminders, and customer support integration. Designed to streamline travel planning and booking management for modern travelers.",
      img: travelacco3,
      category: "Travel & Booking",
      link: "https://traveloacco-frontend.vercel.app",
    },
  ],
  [
    {
      title: "KYCPAL - KYC Verification Platform",
      description:
        "I developed this comprehensive KYC (Know Your Customer) verification platform using modern web technologies. It's a full-stack application featuring identity verification, document authentication, compliance management, automated risk assessment, and secure data handling for streamlined customer onboarding processes.",
      img: kycpal1,
      category: "Fintech Platform",
      link: "https://www.loom.com/share/ce31facaca3b4744ae2bcfce861ae3b5",
    },
    {
      title: "KYCPAL - Document Verification System",
      description:
        "Advanced document verification interface with AI-powered identity validation, OCR technology, biometric authentication, and real-time compliance checks. Built with secure encryption to ensure data privacy and regulatory compliance for financial institutions.",
      img: kycpal2,
      category: "Fintech Platform",
      link: "https://www.loom.com/share/ce31facaca3b4744ae2bcfce861ae3b5",
    },
    {
      title: "KYCPAL - Compliance Dashboard",
      description:
        "Comprehensive compliance management system featuring automated verification workflows, audit trails, risk scoring, reporting tools, and multi-jurisdiction support. Designed to streamline KYC processes while maintaining highest security standards.",
      img: kycpal3,
      category: "Fintech Platform",
      link: "https://www.loom.com/share/ce31facaca3b4744ae2bcfce861ae3b5",
    },
  ],
  [
    {
      title: "Type Out - Typing Speed Tester",
      description:
        "I developed this interactive typing speed testing platform using React.js and modern web technologies. It's a full-stack application featuring real-time WPM tracking, accuracy measurement, multiple difficulty levels, customizable text passages, and performance analytics for improving typing skills.",
      img: typeOut1,
      category: "Web Application",
      link: "https://typing-speed-tester-kappa.vercel.app/",
    },
    {
      title: "Type Out - Practice & Performance",
      description:
        "Advanced typing practice interface with customizable time limits, word count modes, mistake highlighting, and detailed statistics tracking. Built with responsive design to provide seamless typing practice experience across all devices.",
      img: typeOut2,
      category: "Web Application",
      link: "https://typing-speed-tester-kappa.vercel.app/",
    },
    {
      title: "Type Out - Analytics Dashboard",
      description:
        "Comprehensive typing analytics system featuring WPM history, accuracy trends, personal best records, progress graphs, and performance comparisons. Designed to help users track improvement and achieve typing mastery.",
      img: typeOut3,
      category: "Web Application",
      link: "https://typing-speed-tester-kappa.vercel.app/",
    },
  ],
  [
    {
      title: "Kalbosoft - Digital Agency Platform",
      description:
        "I developed this professional digital agency website using Next.js and modern web technologies. It's a full-stack platform featuring service showcase, portfolio management, client testimonials, team profiles, and contact management system for comprehensive agency operations.",
      img: kalbosoft1,
      category: "Agency Website",
      link: "https://kalbosoft.com",
    },
    {
      title: "Kalbosoft - Portfolio Showcase",
      description:
        "Advanced portfolio presentation system with project galleries, case studies, client success stories, and service offerings. Built with responsive design and modern UI/UX to showcase agency expertise and attract potential clients.",
      img: kalbosoft2,
      category: "Agency Website",
      link: "https://kalbosoft.com",
    },
    {
      title: "Kalbosoft - Client Management",
      description:
        "Comprehensive agency management interface featuring client onboarding, project tracking, team collaboration tools, and automated reporting systems. Designed to streamline agency workflows and enhance client communication.",
      img: kalbosoft3,
      category: "Agency Website",
      link: "https://kalbosoft.com",
    },
  ],
  [
    {
      title: "Batting King - Live Betting Interface",
      description:
        "I built this comprehensive bet gaming platform using React.js and modern CSS frameworks. It's a full-stack betting application featuring real-time odds, user account management, betting history, and secure payment processing for sports betting enthusiasts.",
      img: battingKing1,
      category: "Gaming Dashboard",
    },
    {
      title: "Batting King - Betting Categories",
      description:
        "Advanced live betting interface with real-time score updates, dynamic odds calculation, and instant bet placement functionality. Built with responsive design to ensure seamless experience across all devices for sports betting.",
      img: battingKing2,
      category: "Gaming Dashboard",
    },
    {
      title: "Batting King - Transaction History",
      description:
        "Comprehensive analytics dashboard for betting statistics, win/loss tracking, performance metrics, and detailed reporting. Features interactive charts and data visualization to help users analyze their betting patterns and success rates.",
      img: battingKing3,
      category: "Gaming Dashboard",
    },
    {
      title: "Batting King - Payment Processing",
      description:
        "Comprehensive analytics dashboard for betting statistics, win/loss tracking, performance metrics, and detailed reporting. Features interactive charts and data visualization to help users analyze their betting patterns and success rates.",
      img: battingKing4,
      category: "Gaming Dashboard",
    },
  ],
  [
    {
      title: "Ummaah Dashboard - Main Admin Panel",
      description:
        "I developed this comprehensive mosque management dashboard using React.js and modern CSS frameworks. It's a full-stack application featuring member management, prayer time scheduling, donation tracking, event organization, and administrative oversight for mosque operations.",
      img: rafiq_5,
      category: "Mosque Management",
    },
    {
      title: "Ummaah Dashboard - Prayer Management System",
      description:
        "Advanced prayer management interface with automated prayer time calculations, imam scheduling, congregation tracking, and announcement systems. Built with responsive design to support mosque administrators in managing daily prayer activities.",
      img: rafiq_2,
      category: "Mosque Management",
    },
    {
      title: "Ummaah Dashboard - Donation & Finance Tracker",
      description:
        "Comprehensive financial management system featuring donation tracking, expense monitoring, budget planning, and financial reporting tools. Provides mosque administrators with complete oversight of financial operations and transparency.",
      img: rafiq_3,
      category: "Mosque Management",
    },
    {
      title: "Ummaah Dashboard - Member & Community Portal",
      description:
        "Member management system with community engagement features, membership registration, family profiles, volunteer coordination, and communication tools for building stronger mosque community connections.",
      img: rafiq_4,
      category: "Mosque Management",
    },
  ],
  [
    {
      title: "Watcher Admin - Main Dashboard",
      description:
        "I built this comprehensive admin monitoring platform using React.js and modern CSS frameworks. It's a full-stack application featuring real-time system monitoring, user management, analytics reporting, and automated alert systems for efficient administrative oversight.",
      img: watcherAd1,
      category: "Admin Dashboard",
    },
    {
      title: "Watcher Admin - Analytics Panel",
      description:
        "Advanced analytics dashboard with real-time data visualization, performance metrics tracking, user behavior analysis, and comprehensive reporting tools. Built with responsive design to provide seamless administrative control across all devices.",
      img: watcherAd2,
      category: "Admin Dashboard",
    },
    {
      title: "Watcher Admin - Security Control Center",
      description:
        "Comprehensive security monitoring interface featuring threat detection, access control management, audit logging, and automated security protocols. Provides administrators with complete oversight of system security and user access management.",
      img: watcherAd3,
      category: "Admin Dashboard",
    },
  ],
  [
    {
      title: "Estatein - Real Estate Platform",
      description:
        "I developed this comprehensive real estate platform using React.js and modern web technologies. It's a full-stack application featuring property listings, advanced search filters, virtual tours, mortgage calculators, and agent management for professional real estate services.",
      img: Estatein,
      category: "Real Estate",
    },
    {
      title: "Estatein - Property Management Website",
      description:
        "Advanced property management interface with listing management, client relationship tools, market analytics, lead tracking, and automated valuation models. Built with responsive design to support real estate professionals in managing their business operations.",
      img: Estatein_2,
      category: "Real Estate",
    },
  ],
  [
    {
      title: "URL Shortener - Main Dashboard",
      description:
        "I developed this comprehensive URL shortening platform using React.js and modern web technologies. It's a full-stack application featuring link management, analytics tracking, custom aliases, QR code generation, and user authentication for professional URL shortening services.",
      img: URLShortner_1,
      category: "Web Application",
    },
    {
      title: "URL Shortener - Analytics & Tracking System",
      description:
        "Advanced analytics dashboard with click tracking, geographic data visualization, referrer analysis, and detailed reporting tools. Built with responsive design to provide comprehensive insights into link performance and user engagement metrics.",
      img: URLShortner_2,
      category: "Web Application",
    },
  ],
  [
    {
      title: "Order.UK - Food Delivery Platform",
      description:
        "I developed this food delivery platform using Next.js and Tailwind CSS. It's a full-stack application featuring order management, restaurant search, payment processing, and delivery tracking for online food ordering experience.",
      img: orderUK,
      category: "Food Website",
    },
  ],
];
